import { useI18n } from '@i18n/useI18n';
import { useState } from "react";
import { LectureBlockContainer } from "./LectureBlock.styled";
import Tooltip from "@components/Tooltips/Tooltip";
interface IProps {
    timeblock: any,
    selected: boolean,
    selectLectures: (id,all) => void
}
const LectureBlock = (props:IProps) => {
    const i18n = useI18n();
    const [clicked, setClicked] = useState(false);

    const getTime = () => {
         let starttime = props.timeblock.starttime?.hours?.toLocaleString('en-US', {
                 minimumIntegerDigits: 2,
                 useGrouping: false
             }) + ":" + props.timeblock.starttime?.minutes?.toLocaleString('en-US', {
                 minimumIntegerDigits: 2,
                 useGrouping: false
             })
             let endtime = props.timeblock.endtime?.hours?.toLocaleString('en-US', {
                 minimumIntegerDigits: 2,
                 useGrouping: false
             }) + ":" + props.timeblock.endtime?.minutes?.toLocaleString('en-US', {
                 minimumIntegerDigits: 2,
                 useGrouping: false
             })

             let lectureTime = starttime + " - " + endtime
             return lectureTime
    }

    return (
        <Tooltip content={i18n.t(false?'absence-disabled':false?'absence-deselect':'absence-select')}>
            <LectureBlockContainer selected={props.selected} disabled={false} onClick={() => props.selectLectures(props.timeblock.id, false)}>
                <span><b>{i18n.t("time")}</b>: {getTime()}</span>
                {true?<span><b>{i18n.t("course")}</b>: {props.timeblock.name}</span>:<></>}
                {true?<span><b>{i18n.t("subject")}</b>: {props.timeblock.displayname}</span>:<></>}
                {true?<span><b>{i18n.t("room")}</b>: {props.timeblock.roomdisplayname}</span>:<></>}
            </LectureBlockContainer>
        </Tooltip>
    )
}

export default LectureBlock;